module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.878ad71.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Regular.woff
// module id = lBtM
// module chunks = 0